enum DicomUploadStatus {
  'UPLOAD_INPROGRESS' = 'UPLOAD_INPROGRESS',
  'UPLOAD_COMPLETE' = 'UPLOAD_COMPLETE',
}

export { DicomUploadStatus }
